<template>
    <li class="back-btn">
        <a href="javascript:void(0);" @click.prevent="back($event)">Back</a>
    </li>
</template>

<script>
  /* globals $ */

  export default {
    name: 'BackItem',
    methods: {
      back($event) {
        const parent = $($event.target).parent().parent();
        const siblingParent = $($event.target).parent().parent().siblings()
          .parent()
          .parent();
        parent.removeClass('in-view');
        siblingParent.removeClass('off-view');
        $event.preventDefault();
      },
    },
  };
</script>
